import React, { Component } from "react";
import "./Company.css";

class Company extends Component {
  render() {
    return (
      <>
        <h1
          style={{ textAlign: "center", marginTop: "100px", fontSize: "100px" }}
        >
          Company Details
        </h1>
        <div className="first-div">
          <div className="first-div-1">
            <div className="first-div-1-1"><h3>NAME and ADDRESS OF THE ENTITY WITH FSSAI and CIN NUMBER</h3><br/></div> 
            <p>
              Geddit Convenience Private
               Limited, CIN:
               U52100MH2021PTC362722
              
              Ground Floor, Rahat Manzil,
               Dr. AmbedkarRoad, Nr
               Samudra Hotel, Khar West,
               Mumbai City, Maharashtra
               400052
              ‍ FSSAI No 11521998000248
            </p>
          </div>
          <div className="first-div-2">
            <div className="first-div-1-2"><h3>OPERATING CITIES</h3><br/><br/><br/></div> 
            <p>
              Delhi NCR, Mumbai, Pune, Bangalore, Kolkata, Chennai, Hyderabad
            </p>
          </div>
          <div className="first-div-3">
             <div className="first-div-1-3"><h3>CUSTOMER CARE CONTACT DETAILS</h3><br/><br/></div>
            <p>
              Geddit Convenience Private Limited, Ground Floor, Rahat Manzil,
              Dr. Ambedkar Road, Nr Samudra Hotel, Khar West, Mumbai City,
              Maharashtra 400052 ‍ ‍support@zeptonow.com ‍ ‍+917777091021
            </p>
          </div>
          <div className="first-div-4">
            <div className="first-div-1-4"><h3>NODAL/GRIEVANCE OFFICER NAME, EMAIL ADDRESS,CONTACT DETAILS</h3></div>
            <p>Name: MANOJ SETHIA Email: acc.geddit@gmail.com</p>
          </div>
        </div>
      </>
    );
  }
}
export default Company;
